import React from 'react';
import { AgFinancingDocumentType, AgFinancingFile } from '@indigo-ag/schema';

import { PledgeCertificateDocument } from './PledgeCertificateDocument/PledgeCertificateDocument';
import { ValidateDocument } from './ValidateDocument/ValidateDocument';

interface DocumentValidationDetailProps {
  file: AgFinancingFile;
  readonly?: boolean;
}

export const DocumentValidationDetail: React.FunctionComponent<DocumentValidationDetailProps> = ({
  file,
  readonly = false
}) => {
  return file.documentType === AgFinancingDocumentType.CERTIFICATE_OF_PLEDGE ? (
    <PledgeCertificateDocument file={file} readonly={readonly} />
  ) : (
    <ValidateDocument file={file} readonly={readonly} />
  );
};
